import { LoginService } from 'src/app/components/Shared/Service/login_service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { ToastrService } from 'ngx-toastr'
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatSelectChange, MatTableDataSource } from '@angular/material';
import beautify from 'xml-beautifier';
import { DashboarduiService } from '../Shared/Service/dashboardui.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { interval } from 'rxjs';
import { ExcelServicesService } from '../Shared/Service/excel-services';

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
export class idsProductList {
  id: number;
  status: String;
  hotelName: String;
  accountingDate: any;
  pusheddate: any;
  type: any
}
@Component({
  selector: 'app-inv-fxcrs-newpipe',
  templateUrl: './inv-fxcrs-newpipe.component.html',
  styleUrls: ['./inv-fxcrs-newpipe.component.css'],
  providers: [LoginService,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ]
})
export class InvFxcrsNewpipeComponent implements OnInit {
  apiresult: any;
  SearchTokenData = ''
  errorMsgSubscription: boolean;
  displayContent: boolean;
  XMLName: any;
  hotelSearchDataStatus: any;
  heartBeatData: any;
  errorMessage: string;
  dropdownDeptData: any;
  productType: any;
  today = new Date();
  requestPayload: any;
  filterProperty: any
  constructor(private excelService: ExcelServicesService,private apiCallIdsService: DashboarduiService, private toastr: ToastrService, private datePipe: DatePipe, public loginService: LoginService) { }
  dropdownSettings = {};
  status: any = [] = [];
  defaultData: any = [] = [];
  display: Boolean = false;
  rateCode: string;
  selectedDate: any = new Date();
  isProgressing: Boolean = false;
  public Pmscodevalue: any;
  pageSize = 50;
  PGF = 0
  PGT = 50
  public idsProductList: idsProductList[] = [];
  dataSource: MatTableDataSource<idsProductList>
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  displayedColumns: string[] = ['Status', 'token', 'createdatetime','lastupdatedatetime', 'FN_Request', 'TOCRS_Request', 'CRS_Response'];
  totalcount: any = 0;
  Val: string;
  selectedItems: string;
  Userid: any = [];
  /* Search Field */
  dropdownSettingsDept: IDropdownSettings = {};
  selectedDeptItems: any;

  currentDateStore: any;
  storeHeartBeatValue: any;
  blinkOfflineHotel: boolean;
  todayFuture: any = new Date();
  minDay: any = new Date(this.todayFuture.setDate(this.todayFuture.getDate() - 30));
  todayFutureOneDay: any = new Date(this.todayFuture.setDate(this.todayFuture.getDate() + 1));
  futureOneYear: any = new Date();
  futureOneYearDate: any = new Date(this.futureOneYear.setDate(this.futureOneYear.getDate() + 365));
  addBtnDisabledFunc: boolean = true;
  excelFunction: boolean = false;
  ngOnInit() {
    this.isProgressing = true;
    this.callIDSUsersProperties();
    this.errorMsgSubscription = true
    this.errorMessage = "Please select property and load"
    this.displayContent = false
    this.dropdownSettingsDept = {
      idField: 'pmscode',
      textField: 'pmsname',
      allowSearchFilter: true,
      singleSelection: true,
      enableCheckAll: false,
      closeDropDownOnSelection: true,
      itemsShowLimit: 7,
      noDataAvailablePlaceholderText: 'No Data Found',
      searchPlaceholderText: "Search Hotel Code / Name",
    };
  }
  callIDSUsersProperties() {
    this.Userid = localStorage.getItem("Username");
    console.log(this.Userid)
    this.apiCallIdsService.getFXCRSNewPipeProperty()
      .subscribe(
        data => {
          console.log('New Screen Data', data)
          this.apiresult = data
          this.dropdownDeptData = this.apiresult
          this.isProgressing = false;
        });

  }

  changePropertySearch() {
    //console.log('selectedDeptItems = ',this.selectedDeptItems.length)
    if (this.selectedDeptItems) {
      if (this.selectedDeptItems.length > 0) {
        // this.totalcount = 0
        console.log('if condition')
        this.totalcount = 0
        this.Pmscodevalue = this.selectedDeptItems[0].pmscode
        console.log('pms code value = ', this.Pmscodevalue)
        this.errorMsgSubscription = true
        this.errorMessage = "Please select property and load"
        this.displayContent = false
        this.addBtnDisabledFunc = false
        // For Online Status
        this.apiCallIdsService
          .readHotelSearch(this.Pmscodevalue)
          .subscribe((data) => {
            console.log('readHotelSearch =', data)
            this.hotelSearchDataStatus = data[0].recordstatus
            this.productType = data[0].producttype
          });
        this.apiCallIdsService
          .readHeartbeat(this.Pmscodevalue)
          .subscribe((data) => {
            console.log('readHeartbeat =', data[0])
            this.heartBeatData = data[0].heartBeat


            // For blinking the record
            const today = new Date()
            console.log('Today Date = ', today);
            this.currentDateStore = today.toLocaleTimeString('it-IT')
            console.log('Today Date = ', this.currentDateStore);
            this.storeHeartBeatValue = this.GetParseonlyDateTime(this.heartBeatData)
            var start = this.storeHeartBeatValue.split(":");
            var end = this.currentDateStore.split(":");
            var startDate = new Date(0, 0, 0, start[0], start[1], 0);
            var endDate = new Date(0, 0, 0, end[0], end[1], 0);
            var diff = endDate.getTime() - startDate.getTime();
            var hours = Math.floor(diff / 1000 / 60 / 60);
            diff -= hours * 1000 * 60 * 60;
            var minutes = Math.floor(diff / 1000 / 60);
            // console.log('minutes difference',minutes)
            console.log('minutes difference', hours + ":" + minutes)
            if ((hours + ":" + minutes) > "0:30") {
              console.log('blinkOfflineHotel true')
              this.blinkOfflineHotel = true
            } else {
              console.log('blinkOfflineHotel false')
              this.blinkOfflineHotel = false
            }

          });
        interval(2000 * 60).subscribe(() => {
          this.heartbeatFunction();
        });
      }
      else {
        console.log('Else condition zero')
        this.errorMsgSubscription = true
        this.addBtnDisabledFunc = true
        this.errorMessage = "Please select property and load"
        this.displayContent = false
        this.excelFunction = false
      }
    } else {
      console.log('Property Not Selected')
    }
  }


  GetParseonlyDateTime(d: any) {
    console.log('GetParseonlyDateTime call', d.substring(12))
    return (d.substring(12));
  }

  heartbeatFunction() {
    this.apiCallIdsService
      .readHeartbeat(this.Pmscodevalue)
      .subscribe((data) => {
        console.log('readHeartbeat =', data[0])
        this.heartBeatData = data[0].heartBeat
      });
  }

  closeModalDialog() {
    this.display = false; //set none css after close dialog
  }

  LoadXML(xmltype: any, token: any) {
    this.isProgressing = true;
    this.apiCallIdsService.getFXCRSNewPipeXML(token, xmltype)
      .subscribe(data => {
        if (data.length < 1) {
          this.toastr.error('No data to load');
        }else{
          const xml = beautify(data[0].xmlData);
          console.log(xml);
          if(xmltype == 'FN_Request'){
            this.XMLName = 'FN Request'
          }else if(xmltype == 'TOCRS_Request'){
            this.XMLName = 'TOCRS Request'
          }else if(xmltype == 'CRS_Response'){
            this.XMLName = 'CRS Response'
          }
          this.defaultData = xml;
          this.display = true;
          this.isProgressing = false;
        }
      },
        error => {
          this.toastr.error("Falied to load requests !");
          this.isProgressing = false;
        },

      );
  }

  GetInventory() {
    this.isProgressing = true;
    this.selectedDate = this.datePipe.transform(this.selectedDate, 'yyyy-MM-dd');
    this.requestPayload = {
      "PMSCODE": this.Pmscodevalue,
      "SENTDATE": this.selectedDate,
      "TOKEN": this.SearchTokenData,
      "PaginationFromId":this.PGF,
      "PaginationToId":this.PGT
    }
    console.log('requestPayload data = ', this.requestPayload)
    this.apiCallIdsService.getFXCRSNewPipelog(this.requestPayload)
      .subscribe(
        data => {
          console.log('260 = ',data)
          if(data[0].totalCount < 1 || data.length == 0){
            this.displayContent = false
            this.errorMsgSubscription = true
            this.excelFunction = false
            this.errorMessage = "No Data Found"
            this.toastr.error('No Data Found');
            this.isProgressing = false;
          }else {
            this.errorMsgSubscription = false
          this.displayContent = true
          this.excelFunction = true
          this.idsProductList=data;
          this.filterProperty = this.idsProductList
          this.totalcount = data[0].totalCount;
          this.dataSource = new MatTableDataSource(this.idsProductList);
          this.dataSource.paginator = this.paginator;
          this.toastr.success('Data Loaded Successfully');
          this.isProgressing = false;
          }
        });
  }
  pageEvent(e: any) {
    console.log('pageEvent = ', e)
    var pageIndex = e.pageIndex;
    pageIndex = pageIndex;
    console.log('pageIndex = ', pageIndex)
    this.pageSize = e.pageSize
    console.log('pageSize = ', this.pageSize)
    this.PGF = this.pageSize * pageIndex + 1;
    this.PGT = this.PGF + e.pageSize - 1;
    console.log("this.PGF", this.PGF)
    console.log("this.PGT", this.PGT)
    this.GetInventory();
  }

   /* Excel Download */

   exportAsXLSX() {
    this.Userid = localStorage.getItem("Username");
    console.log(this.Userid)
    var filterArray = [];
    var slno = 1;
    const excelTitle = "Inventory Delivery to FX CRS NewPipe";
    const excelDownloadTitle = "Inventory Delivery to FX CRS NewPipe";
    const title = "Title: " + excelTitle;
    const role = "Role: " + "IDS User";
    const bindFirstName = "EmailId: " + this.Userid;
    const header = ['S.NO','Status','Hotel Code', 'Token', 'Created Date','Last Updated Date','FN Request','TOCRS Request','CRS Response'];
    for (var i in this.filterProperty) {
      filterArray.push([
        slno, this.filterProperty[i].sts,this.filterProperty[i].pmscode, this.filterProperty[i].token, this.datePipe.transform(this.filterProperty[i].createdatetime, 'dd-MMM-yyyy, HH:mm'),this.datePipe.transform(this.filterProperty[i].lastupdatedatetime, 'dd-MMM-yyyy, HH:mm'),"XML","XML","XML"
      ])
      slno = slno + 1;
    }

    this.excelService.ExcelInvDeliveryToFXCRS(filterArray, bindFirstName, title, role, header, excelTitle, excelDownloadTitle);
  }
}
